import React from "react";
import ModalFormUI from "../../../widgets/form/ModalFormUI";
import InputSelectSF from "../../../widgets/form/InputSelectSF";
const LenderUpdateModalUI = ({
	context, successMsg, errorList, setErrorList,
	createMode, onSubmit, submitted, onCancelCreate, lendersList,
	lender, onLenderChange, lenderError, setLenderError
}) =>
	<ModalFormUI
		context={context}
		titleLabel='Select Lender'
		buttonLabel='Update'
		cancelLabel='Cancel'
		isOpen={createMode}
		onRequestClose={onCancelCreate}
		successMsg={successMsg}
		errorList={errorList}
		setErrorList={setErrorList}
		onSubmit={onSubmit}
		busy={submitted}
	>
		<div className='col'>
			<InputSelectSF type='name' name='selectLender'
				label='Lender' optionList={lendersList}
				value={lender} onChange={onLenderChange}
				error={lenderError} setError={setLenderError}
			/>
		</div>
	</ModalFormUI>
export default LenderUpdateModalUI;